import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

export default class ProjectSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
        };
    }

    componentWillMount() {
        if (this.props.fetchProjects) {
            this.props.fetchProjects();
        }
    }

    handleChange(project) {
        console.log("handleChange", project);
        this.props.handleChange(project);
    }

    render() {
        const projects = [];
        if (this.props.projects) {

            if (this.props.areCommercials) {
                projects.push({ value: null, label: "TODOS" });
            }
            this.props.projects.map((project) => {
                projects.push({ value: project.id, label: project.name })
            });
        }
        return (
            <OgaSelect
                bsSize="small"
                disabled={this.props.disabled}
                placeholder={this.props.placeholder}
                value={this.props.selection}
                onChange={(project) => this.handleChange(project)}
                options={projects} />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ProjectSelect/ProjectSelect.jsx